// extracted by mini-css-extract-plugin
export default {"page":"style_page__2MZ8V","content":"style_content__FHWyL","noFooter":"style_noFooter__EoWl0","preventScroll":"style_preventScroll__B2fAU"};